// hooks
import { Fragment, useEffect, useState, useCallback } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import useHttp from "hooks/use-http";

// routes
import { useParams, useNavigate } from "react-router-dom";

// material styles
import { Grid, Button, TextField } from "@mui/material";

// material icons
import CheckIcon from "@mui/icons-material/Check";

// react icons
import { MdDelete } from "react-icons/md";

// components
import LoadingCM from "components/shared/Loading";
import DrawerCM from "components/shared/Drawer";
import BackButton from "components/shared/BackButton";
import DeleteModal from "components/shared/Modal/Delete";

// helper
import Toast from "helper/toast";

// styled component
import {
  StyledStack,
  StyledTitle,
  ButtonContainer,
} from "./editSubCategory.style";

// request methods
import {
  deleteRecordSubCategoryByIdRequest,
  editRecordSubCategoryRequest,
  getRecordSubcategoryByIdRequest,
} from "api/requests/records";

// validation
import { categorySchema } from "validations";

export default function EditRecordsSubCategory() {
  const { records_subcategory_id } = useParams();

  const navigate = useNavigate();

  const { request, loading, setLoading } = useHttp(false);

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(categorySchema),
  });

  // show modal state
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  // show modal handler
  const handelShowModal = () => setShowDeleteModal((state) => !state);

  // delete record subcategory
  const handleDeleteItem = useCallback(
    async (id) => {
      setLoading(false);
      const res = await request({
        url: () => deleteRecordSubCategoryByIdRequest(id),
      });
      if (res) {
        Toast({ type: "success", title: "حذف زیردسته سوابق " });
        navigate("/records/subcategory/add");
      }
      handelShowModal();
    },
    [setLoading]
  );

  // get subcategories data
  const getSubCategoryData = useCallback(async () => {
    setLoading(true);

    const res = await request({
      url: () =>
        getRecordSubcategoryByIdRequest({ id: records_subcategory_id }),
    });

    setLoading(false);
    if (res) {
      reset({
        title: res.data.title,
      });
    }
  }, [request]);

  // edit subcategory
  const onSubmit = async (data) => {
    const res = await request({
      url: () =>
        editRecordSubCategoryRequest({ ...data, id: records_subcategory_id }),
    });
    setLoading(false);
    if (res) {
      reset({
        title: "",
      });
      Toast({ type: "success", title: "ثبت زیردسته " });
      navigate("/records/subcategory/add");
    }
  };

  useEffect(() => {
    getSubCategoryData();
  }, [getSubCategoryData]);
  return (
    <DrawerCM title="ویرایش زیردسته سوابق">
      {loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          <Grid container>
            <Grid item mt={3} xs={12}>
              <BackButton Route="/records/subcategory/add" />
            </Grid>
            <StyledStack>
              <Grid>
                <StyledTitle>ویرایش زیردسته سوابق </StyledTitle>
                <Grid container>
                  <Grid item xs={12} p={1.5}>
                    <TextField
                      label="عنوان زیردسته"
                      variant="outlined"
                      fullWidth
                      id="title"
                      {...register("title")}
                      error={Boolean(errors.title)}
                      helperText={errors.title?.message}
                    />
                  </Grid>
                  <ButtonContainer item xs={12}>
                    <Button
                      color="success"
                      startIcon={<CheckIcon />}
                      variant="contained"
                      sx={{ mt: 1, mr: 1 }}
                      onClick={handleSubmit(onSubmit)}
                    >
                      ثبت
                    </Button>
                    <Button
                      color="error"
                      endIcon={<MdDelete />}
                      variant="contained"
                      sx={{ mt: 1, mr: 1 }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handelShowModal();
                      }}
                    >
                      حذف
                    </Button>
                  </ButtonContainer>
                </Grid>
              </Grid>
            </StyledStack>
          </Grid>
          <DeleteModal
            show={showDeleteModal}
            onClose={handelShowModal}
            onDelete={handleDeleteItem.bind(null, records_subcategory_id)}
          />
        </Fragment>
      )}
    </DrawerCM>
  );
}
